import byteliveApi from './api/byteliveApi';
import { objectToQueryString } from '../utils';

const initialState = {
};

export default (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const callbackList = (payload) => {
    return dispatch => {
        const queryString = objectToQueryString(payload);
        return byteliveApi.get(`/callback${queryString}`).then(data => {
            return data;
        }).catch(error => {
            throw (error);
        });
    };
}

export const callbackCreate = (payload) => {
    return dispatch => {
        return byteliveApi.post(`/callback`, payload).then(data => {
            return data;
        }).catch(error => {
            throw (error);
        });
    };
}

export const callbackUpdate = (id, payload) => {
    return dispatch => {
        return byteliveApi.patch(`/callback/${id}`, payload).then(data => {
            return data;
        }).catch(error => {
            throw (error);
        });
    };
}

export const callbackDelete = (id) => {
    return dispatch => {
        return byteliveApi.delete(`/callback/${id}`).then(data => {
            return data;
        }).catch(error => {
            throw (error);
        });
    };
}

export const callbackGetEventTypes = () => {
    return dispatch => {
        return byteliveApi.get(`/callback/types`).then(data => {
            return data;
        }).catch(error => {
            throw (error);
        });
    };
}